import { DataTableInterface } from "../types/interface";

const extra62Data: DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "240,000", derniers: "160,000" },
];

// EXTRA 6 - 3 numéros
const extra63Data: DataTableInterface[] = [
    { number: "3", bonus: "0", premiers: "2,000,000", derniers: "1,200,000" },
    { number: "2", bonus: "0", premiers: "48,000", derniers: "32,000" },
];

// EXTRA 6 - 4 numéros
const extra64Data: DataTableInterface[] = [
    { number: "4", bonus: "0", premiers: "13,000,000", derniers: "8,000,000" },
    { number: "3", bonus: "0", premiers: "400,000", derniers: "250,000" },
    { number: "2", bonus: "0", premiers: "24,000", derniers: "16,000" },
];

// EXTRA 6 - 5 numéros
const extra65Data: DataTableInterface[] = [
    { number: "5", bonus: "0", premiers: "130,000,000", derniers: "90,000,000" },
    { number: "4", bonus: "0", premiers: "7,000,000", derniers: "4,000,000" },
    { number: "3", bonus: "0", premiers: "140,000", derniers: "90,000" },
    { number: "2", bonus: "0", premiers: "12,000", derniers: "8,000" },
];

// EXTRA 7 - 2 numéros
const extra72Data: DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "180,000", derniers: "110,000" },
];

// EXTRA 7 - 3 numéros
const extra73Data: DataTableInterface[] = [
    { number: "3", bonus: "0", premiers: "1,500,000", derniers: "1,000,000" },
    { number: "2", bonus: "0", premiers: "30,000", derniers: "20,000" },
];

// EXTRA 7 - 4 numéros
const extra74Data: DataTableInterface[] = [
    { number: "4", bonus: "0", premiers: "10,000,000", derniers: "7,000,000" },
    { number: "3", bonus: "0", premiers: "220,000", derniers: "150,000" },
    { number: "2", bonus: "0", premiers: "18,000", derniers: "12,000" },
];

// EXTRA 7 - 5 numéros
const extra75Data: DataTableInterface[] = [
    { number: "5", bonus: "0", premiers: "180,000,000", derniers: "120,000,000" },
    { number: "4", bonus: "0", premiers: "3,600,000", derniers: "2,400,000" },
    { number: "3", bonus: "0", premiers: "48,000", derniers: "32,000" },
    { number: "2", bonus: "0", premiers: "9,000", derniers: "6,000" },
];


export const extra6Data = [
    {
        game: "EXTRA 6 - 2 numéros",
        data: [...extra62Data]
    },
    {
        game: "EXTRA 6 - 3 numéros",
        data: [...extra63Data]
    },
    {
        game: "EXTRA 6 - 4 numéros",
        data: [...extra64Data]
    },
    {
        game: "EXTRA 6 - 5 numéros",
        data: [...extra65Data]
    }   
]

export const extra7Data = [
    {
        game: "EXTRA 7 - 2 numéros",
        data: [...extra72Data]
    },
    {
        game: "EXTRA 7 - 3 numéros",
        data: [...extra73Data]
    },
    {
        game: "EXTRA 7 - 4 numéros",
        data: [...extra74Data]
    },
    {
        game: "EXTRA 7 - 5 numéros",
        data: [...extra75Data]
    }   
]